export default __webpack_public_path__ + "static/media/snails.9fef06e1.jpg";